import React, { Component } from "react";
import {Button} from "react-bootstrap";
import axios from "axios";

class ActionButton extends Component {

    state = {
        variant: 'default',
        size: '',
        actionType: null,
        actionKey: null,
        actionValue: null,
    }

    componentDidMount() {
        this.setState({
            variant: this.props.variant,
            size: this.props.size,
            actionType: this.props.actionType,
            actionKey: this.props.actionKey,
            actionValue: this.props.actionValue,
        });
    }

    handleOnClick = () => {
        if(this.state.actionType === "http") {
            this.getActionHttp(this.state.actionValue)
                .then(
                    (res) => {
                        console.log(res)
                    }
                )
        }
    }

    getActionHttp = (url) => {
        return axios.get(url)
            .then(
                res => {
                    return res.data
                }
            )
    }


    render() {
        return (
            <Button
                variant={this.state.variant}
                size={this.state.size}
                onClick={(this.handleOnClick)}
                >
                { this.props.children }
            </Button>
        );
    }
}
export default ActionButton;
